import { useCallback, useState } from "react";
import { AxiosResponse } from "axios";
import { NotificationType, SurveyData } from "pages/Survey/types";

interface IAsyncJsonData {
  jsonData: SurveyData | null;
  isLoading: boolean;
  errorData: string;
  handleGetJson: (
    apiCall: Promise<AxiosResponse>,
    notification?: (type: NotificationType, message: string) => void
  ) => Promise<boolean>;
}

const useAsyncJsonData = (): IAsyncJsonData => {
  const [jsonData, setJsonData] = useState<any>(null);
  const [errorData, setErrorData] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleGetJson = useCallback(
    async (
      apiCall: Promise<AxiosResponse>,
      notification?: (type: NotificationType, message: string) => void
    ) => {
      setIsLoading(true);
      setErrorData("");

      try {
        const { data } = await apiCall;

        if (data.status === "success") {
          await setJsonData(data.data);
          return true;
        } else if (data.status === "error") {
          await setErrorData(data.data);
          return false;
        }

        await setErrorData("Помилка. Спробуйте пізніше.");
        return false;
      } catch (error: any) {
        if (typeof notification === "function") {
          notification("error", error.message);
        }
        setErrorData(error.message);
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { jsonData, isLoading, handleGetJson, errorData };
};

export default useAsyncJsonData;
